module.exports = __webpack_public_path__ + "img/kibana.fb9e3e34.svg";